import React from 'react';
import AssignGroupManagementRouter from './AssignGroupManagementRouter';

export default function AssignGroupManagementPage() {
  return <AssignGroupManagementRouter />;
}
